import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const BarChartGr = props => {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                width={700}
                height={300}
                data={props.data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                {props.graph === 1 ? (
                    <>
                        <Bar dataKey="cantidad" fill="#ff7300" />
                    </>
                ) : props.graph === 2 ? (
                    <>
                        <Bar dataKey="total" fill="#413ea0" />
                    </>
                ) : props.graph === 3 && (
                    <>
                        <Bar dataKey="Efectivo" fill="#FF8042" />
                        <Bar dataKey="Débito" fill="#FFBB28" />
                        <Bar dataKey="Crédito" fill="#ff7300" />
                        <Bar dataKey="Transf" fill="#00C49F" />
                        <Bar dataKey="Otro" fill="#413ea0" />

                    </>
                )}
            </BarChart>
        </ResponsiveContainer>
    )
}

export default BarChartGr